import createReducer from '../../createReducer';
import {
  FETCH_GRAPH_WAVE_FORECAST,
  FETCH_GRAPH_WAVE_FORECAST_SUCCESS,
  FETCH_GRAPH_WAVE_FORECAST_FAILURE,
} from '../../../actions/graphs';
import transformDataToDays from './helpers/transformDataToDays';

const initialState = {
  error: null,
  loading: true,
  units: null,
  utcOffset: null,
  location: null,
  forecastLocation: null,
  offshoreLocation: null,
  overallMaxSurfHeight: null,
  overallMaxSwellHeight: null,
  days: null,
};

const handlers = {};

handlers[FETCH_GRAPH_WAVE_FORECAST] = () => initialState;

const maxSwell = swells => Math.max(...swells.map(swell => swell.height));

handlers[FETCH_GRAPH_WAVE_FORECAST_SUCCESS] = (state, { intervalHours, response }) => ({
  ...state,
  loading: false,
  units: response.associated.units,
  utcOffset: response.associated.utcOffset,
  location: response.associated.location,
  forecastLocation: response.associated.forecastLocation,
  offshoreLocation: response.associated.offshoreLocation,
  overallMaxSurfHeight: Math.max(...response.data.wave.map(({ surf }) => surf.max)),
  overallMaxSwellHeight: Math.max(...response.data.wave.map(({ swells }) => maxSwell(swells))),
  days: transformDataToDays(
    response.data.wave,
    intervalHours,
    ({ timestamp, surf, swells }) => ({
      timestamp,
      surf,
      swells: swells.map((swell, index) => ({
        ...swell,
        index,
      })),
    }),
  ),
});

handlers[FETCH_GRAPH_WAVE_FORECAST_FAILURE] = (state, { error }) => ({
  ...state,
  error,
  loading: false,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/components/graphs/wave.js